import styled from 'styled-components';

export const SettingsContainer = styled.section`
  width: 100%;
  height: fit-content;
`;
